/**
 * Every option supported in `CloudinaryTransformOptions` should have a corresponding mapped short code
 */
export const CLOUDINARY_TRANSFORM_MAP = {
  aspectRatio: 'ar',
  audioCodec: 'ac',
  crop: 'c',
  effect: 'e',
  flag: 'fl',
  format: 'f',
  gravity: 'g',
  height: 'h',
  page: 'pg',
  pixelRatio: 'dpr',
  quality: 'q',
  startOffset: 'so',
  width: 'w',
  x: 'x',
  y: 'y',
} as const;
